'use strict'

const React = require('react')
const createReactClass = require('create-react-class')
const PropTypes = require('prop-types')
const DiscountAlert = require('../../shared/_layouts/_templates/_includes/discount-alert.jsx')
const HarpAlert = require('../../shared/_layouts/_templates/_includes/harp-alert.jsx')
const Nav = require('../../shared/_layouts/_templates/_includes/nav.jsx')
const Engine = require('core-booking-forms-aps').default
const ProductNav = require('./_includes/homepageProductsNav.jsx')
const ExitDiscountModal = require('../../shared/_layouts/_templates/_includes/modals/ExitDiscountModal.jsx')
const SmartyContent = require('../../shared/_layouts/_templates/_includes/smartyContent.jsx')
const { smartyIncludes, smartyVariables } = require('../../shared/_layouts/_templates/_includes/smartyIncludes.jsx')
const TrackerFix = require('../../shared/_layouts/_templates/_includes/trackerFix')
const Agents = require('../../_plugins/lib/agents')
const Helpers = require('../../_plugins/lib/helpers')
const SplitTestStore = require('../../shared/states/splitTestData.jsx')
const productOptions = require('core-booking-forms-aps/lib/config/productOptions')

const { object } = PropTypes

const Homepage = createReactClass({
  mixins: [Agents, SplitTestStore],

  propTypes: {
    settings: object,
    pageData: object.isRequired,
    agents: object,
    domainSettings: object,
    formSettings: object
  },

  getInitialState () {
    return {
      promotionCode: null,
      userData: null
    }
  },

  setPromotionCode (code) {
    if (code === this.state.promotionCode) return
    this.setState({ promotionCode: code })
  },

  componentDidMount () {
    const { pageData: { html } } = this.props
    let { agentData: { agent } } = this.state
    const { setVar } = smartyVariables(html)
    if (setVar.agent) {
      agent = setVar.agent
      this.checkAgent(agent, this.updateAgentData)
    }
    let environment = 'production'
    if (Helpers.getParameterByName('data-pipeline-staging')) environment = 'staging'
    if (Helpers.getParameterByName('data-pipeline-production')) environment = 'production'
    TrackerFix({
      agent,
      environment,
      templateGroup: 'core'
    })
    window.universalJavascriptLoaded = true
  },

  userLoggedInCallback (userData) {
    this.setState({ userData })
  },

  userLoggedOutCallback () {
    this.setState({ userData: null })
    window.localStorage.clear()
    window.sessionStorage.clear()
    const cookies = document.cookie.split(';')

    for (let i = 0; i < cookies.length; ++i) {
      const cookie = cookies[i].trim()
      const pos = cookie.indexOf('=')
      const name = pos > -1 ? cookie.substr(0, pos) : cookie
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;`
    }
  },

  render () {
    const { agentData, promotionCode } = this.state
    const { settings, pageData, agents: agentSettings, domainSettings, formSettings, imageCloudSettings } = this.props
    const { html } = pageData
    let { content } = smartyVariables(html)
    const showDiscountBanner = !(this.state.userData && this.state.userData.profile)
    content = smartyIncludes(content)
    productOptions.ins.link = 'https://www.holidayextras.co.uk/travel-insurance.html?agent=' + agentData.agent

    return (
      <div className='bannerTest'>
        <Nav promotionCodeCallback={this.setPromotionCode} agents={agentSettings} pageData={pageData} settings={settings} userLoggedInCallback={this.userLoggedInCallback} userLoggedOutCallback={this.userLoggedOutCallback} />
        <DiscountAlert settings={settings} agentData={agentData} />
        <HarpAlert domainSettings={domainSettings} settings={settings} />
        <div>
          <div id='booking-engine' className='col-md-12'>
            <Engine
              agentData={agentData}
              agentSettings={agentSettings}
              domainSettings={domainSettings}
              engineImage
              formSettings={formSettings}
              hotelParkingFlight
              isHomepage
              longerDateLabels={false}
              pageData={pageData}
              productList={['cp', 'hcp', 'ins']}
              productOptions={productOptions}
              promotionCode={promotionCode}
              settings={settings}
              showBookingFeesMessage={false}
              showDiscountBanner={showDiscountBanner}
              showFlight
              showTerminalsField
              terminalLink
              terminalsInLocations={false}
            />
          </div>
          <div className='product-nav well'>
            <ProductNav />
          </div>
          <div className='clearfix'>
            <SmartyContent settings={settings} agentData={agentData} pageData={pageData} theContent={content} noSchemaMarkup />
          </div>
        </div>
        <ExitDiscountModal imageCloudSettings={imageCloudSettings} agentData={agentData} pageData={pageData} />
      </div>
    )
  }
})

module.exports = Homepage



// WEBPACK FOOTER //
// ./_layouts/_templates/homepage-horizontal.jsx